import { h as r } from "vue";
import { renderAvatar as l } from "./ghl-ui.es651.js";
const t = {
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "20px",
  marginLeft: "8px",
  padding: "4px 0px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, s = (e) => r(
  "div",
  {
    style: {
      display: "flex",
      alignItems: "center"
    }
  },
  [
    l(e),
    r(
      "div",
      {
        style: t
      },
      [
        r(
          "p",
          {
            style: {
              margin: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            }
          },
          [e.label]
        ),
        r(
          "span",
          {
            style: {
              color: "var(--gray-500)"
            }
          },
          {
            default: () => e == null ? void 0 : e.description
          }
        )
      ]
    )
  ]
);
export {
  s as renderLabelAsAvatar
};
